import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from "./components/Hero";
import Approach from "./components/Approach";
import Portfolio from "./components/Portfolio";
import WhatWeOffer, { offers } from "./components/WhatWeOffer";
import WhyChoose from "./components/WhyChoose";
import Results from "./components/Results";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from './components/Footer';
import About from './components/About';
import Insights from './components/Insights';
import ServiceDetail from './components/ServiceDetail';
import IndustryDetail from './components/IndustryDetail';
import ScrollToTop from './components/ScrollToTop';
import Loader from './components/Loader';
import { motion, AnimatePresence } from 'framer-motion';
import AOS from "aos";
import "aos/dist/aos.css";
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('home'); // 'home', 'portfolio', 'about', 'insights', 'service-detail', 'industry-detail'

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  React.useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setView('service-detail');
    window.scrollTo(0, 0);
  };

  const handleIndustrySelect = (industryName) => {
    setSelectedIndustry(industryName);
    setView('industry-detail');
    window.scrollTo(0, 0);
  };

  const handlePortfolioSelect = () => {
    setView('home'); 
    setTimeout(() => {
      const element = document.querySelector('#portfolio');
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, 150);
  };

  const handleBackToHome = () => {
    setView('home');
    window.scrollTo(0, 0);
  };

  const handleViewChange = (newView, data = null) => {
    if (newView === 'industry-detail') {
      handleIndustrySelect(data);
    } else if (newView === 'service-detail') {
      const serviceObj = offers.find(o => o.title === data || o.title.includes(data));
      if (serviceObj) {
        handleServiceSelect(serviceObj);
      }
    } else if (newView === 'portfolio') {
      handlePortfolioSelect();
    } else {
      setView(newView);
      window.scrollTo(0, 0);
    }
  };

  return (
    <AnimatePresence mode="wait">
      {loading ? (
        <Loader key="loader" />
      ) : (
        <motion.div 
          key="app-content" 
          className="App" 
          style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh', overflowX: 'hidden' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        >
          <Navbar setView={handleViewChange} currentView={view} />
      <main>
        {view === 'home' || view === 'portfolio' ? (
          <>
            <Hero onPortfolioSelect={handlePortfolioSelect} />
            <Results />
            <WhatWeOffer onServiceSelect={handleServiceSelect} />
            <Portfolio />
            <Approach />
            <WhyChoose />
            <Testimonials />
            <Contact />
          </>
        ) : view === 'about' ? (
          <About />
        ) : view === 'insights' ? (
          <Insights />
        ) : view === 'service-detail' ? (
          <ServiceDetail service={selectedService} onBack={handleBackToHome} />
        ) : view === 'industry-detail' ? (
          <IndustryDetail industryName={selectedIndustry} onBack={handleBackToHome} />
        ) : (
          <>
            <Hero onPortfolioSelect={handlePortfolioSelect} />
            <Results />
            <WhatWeOffer onServiceSelect={handleServiceSelect} />
            <Portfolio />
            <Approach />
            <WhyChoose />
            <Testimonials />
            <Contact />
          </>
        )}
      </main>
          <Footer setView={handleViewChange} />
          <ScrollToTop />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default App;